import urlRegex from 'url-regex';

const validUrl = (string, options={}) => urlRegex(options).test(string);

export default validUrl;
